import type { PublicOnboardRequestDto, PublicOnboardResponseDto } from "@/shared/types/onboard.types";

export class OnboardApiError extends Error {
    status: number;

    code?: string;

    constructor(message: string, status: number, code?: string) {
        super(message);
        this.name = "OnboardApiError";
        this.status = status;
        this.code = code;
    }
}

function parseErrorMessage(data: unknown, fallback: string): string {
    if (!data || typeof data !== "object") return fallback;
    const record = data as Record<string, unknown>;
    if (typeof record.message === "string" && record.message.trim()) return record.message;
    if (typeof record.error === "string" && record.error.trim()) {
        if (record.error === "rate_limit") {
            return "Слишком много запросов. Подождите минуту и попробуйте снова.";
        }
        if (record.error === "telegram_required") {
            return typeof record.message === "string" && record.message.trim()
                ? record.message
                : "Сначала войдите и привяжите Telegram в кабинете.";
        }
        return record.error;
    }
    return fallback;
}

export async function submitPublicOnboard(payload: PublicOnboardRequestDto): Promise<PublicOnboardResponseDto> {
    const response = await fetch("/api/onboard", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
    });

    const data = await response.json().catch(() => ({}));

    if (!response.ok) {
        throw new OnboardApiError(parseErrorMessage(data, "Не удалось запустить onboarding"), response.status, (data as { error?: string }).error);
    }

    return data as PublicOnboardResponseDto;
}

export async function fetchOnboardStatus(jobId: string): Promise<PublicOnboardResponseDto> {
    const response = await fetch(`/api/onboard/status?jobId=${encodeURIComponent(jobId)}`, {
        method: "GET",
        cache: "no-store",
    });

    const data = await response.json().catch(() => ({}));

    if (!response.ok) {
        throw new OnboardApiError(parseErrorMessage(data, "Не удалось получить статус развертывания"), response.status, (data as { error?: string }).error);
    }

    return data as PublicOnboardResponseDto;
}
